/*
All Rights Reserved. Permission to use and distribute this software, source code and its documentation is hereby granted on the terms
and conditions set out in the License Agreement dated August 10, 2018 (‘License Agreement’) between Prashant Sharma and China Guangdong
Jingteng Technology Co., Ltd. This copyright notice shall appear in all copies and distributions to the extent permitted in the License
Agreement. This Software, source code and its documentation may not be used without the prior written consent of Prashant Sharma in any
manner whatsoever except to the extent specified in the License Agreement. Contact Prashant Sharma, B-801, Purva Panorama, Bannerghatta Road,
Bangalore – 560 076, +91 9731217354, spidersharma@gmail.com for any queries on this Software.

IN NO EVENT SHALL PRASHANT SHARMA BE LIABLE TO ANY PARTY FOR DIRECT, INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES, INCLUDING LOST
PROFITS, ARISING OUT OF THE USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF PRASHANT SHARMA HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH
DAMAGE.
PRASHANT SHARMA SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
FOR A PARTICULAR PURPOSE. THE SOFTWARE AND ACCOMPANYING DOCUMENTATION, IF ANY, PROVIDED HEREUNDER IS PROVIDED "AS IS". PRASHANT SHARMA HAS
NO OBLIGATION TO PROVIDE UPDATES, ENHANCEMENTS, OR MODIFICATIONS AND WILL, HOWEVER, PROVIDE TRAINING AND MAINTENANCE TO THE EXTENT AND FOR
THE FEES AS SET OUT IN SCHEDULE B TO THE LICENSE AGREEMENT.
 */

import {
    PlaneGeometry,
    ShaderMaterial,
    DoubleSide,
    AdditiveBlending,
    UniformsUtils,
    Mesh,
    Vector3,
} from "three";

import SparkleShader from './SparkleShader';

class Sparkle {
    constructor(sparkleTexture, noiseTexture) {
        this.texture = sparkleTexture;
        this.noiseTexture = noiseTexture;
        this.geometry = new PlaneGeometry(1, 1, 0);
        this.material = new ShaderMaterial();
        this.material.depthTest = false;
        this.material.depthWrite = false;
        this.material.transparent = true;
        this.material.side = DoubleSide;
        this.material.blending = AdditiveBlending;
        this.material.vertexShader = SparkleShader.vertexShader;
        this.material.fragmentShader = SparkleShader.fragmentShader;
        this.material.uniforms = UniformsUtils.clone(SparkleShader.uniforms);
        if (this.texture !== undefined)
            this.material.uniforms["sparkleTexture"].value = sparkleTexture;
        if (this.noiseTexture !== undefined)
            this.material.uniforms["noiseTexture"].value = noiseTexture;

        this.mesh = new Mesh(this.geometry, this.material);
        this.mesh.positionOffset = new Vector3();
        this.rotationSpeedFactor = 5;
    }

    shallowCopy() {
        var sparkle = new Sparkle(this.texture, this.noiseTexture);
        sparkle.mesh.positionOffset = new Vector3();
        sparkle.mesh.positionOffset.copy(this.mesh.positionOffset);
        sparkle.material.uniforms["scale"].value = this.material.uniforms["scale"].value;
        sparkle.material.uniforms["rotation"].value = this.material.uniforms["rotation"].value;
        sparkle.material.uniforms["intensity"].value = this.material.uniforms["intensity"].value;
        sparkle.material.uniforms["screenTexture"].value = this.material.uniforms["screenTexture"].value;
        sparkle.material.uniforms["noiseTexture"].value = this.material.uniforms["noiseTexture"].value;
        sparkle.material.uniforms["ModelViewMatrix"].value.copy(this.material.uniforms["ModelViewMatrix"].value);
        sparkle.rotationSpeedFactor = this.rotationSpeedFactor;
        return sparkle;
    }

    setScale(scale) {
        this.material.uniforms["scale"].value = scale;
    }

    setIntensity(intensity) {
        this.material.uniforms["intensity"].value = intensity;
    }

    setRotation(rotation) {
        this.material.uniforms["rotation"].value = rotation;
    }

    setRotationSpeedFactor(rotationSpeedFactor) {
        this.rotationSpeedFactor = rotationSpeedFactor;
    }

    setPositionOffset(offsetx, offsety, offsetz) {
        this.mesh.positionOffset.x = offsetx;
        this.mesh.positionOffset.y = offsety;
        this.mesh.positionOffset.z = offsetz;
        this.mesh.position.copy(this.mesh.positionOffset);
        this.mesh.updateMatrix();
    }

    alignWithCamera(camera) {
        this.mesh.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, this.mesh.matrix);
        var matrix = this.material.uniforms["ModelViewMatrix"].value;
        matrix.copy(this.mesh.modelViewMatrix);
    }

    syncWithTransform(transform, offset) {
        this.mesh.position.copy(this.mesh.positionOffset);
        if (offset) {
            this.mesh.position.add(offset);
        }
        this.mesh.position.applyMatrix4(transform);
        this.mesh.updateMatrix();
    }
};

export {
    Sparkle
};